var map = {
	"./roles/roles.module": [
		"./src/app/core/roles/roles.module.ts",
		"common",
		"roles-roles-module"
	],
	"./setup/setup.module": [
		"./src/app/core/setup/setup.module.ts",
		"setup-setup-module"
	],
	"./users/users.module": [
		"./src/app/core/users/users.module.ts",
		"common",
		"users-users-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;